import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import UserProfileEditor from "../components/user/UserProfileEditor";
import UserProfileView from "../components/user/UserProfileView";
import ApplicationTable from "../components/student/ApplicationTable";
import HiringSeasonTable from "../components/faculty/HiringSeasonTable";
import { useSelector } from "react-redux";
import { isAuthenticated } from "../util";

function Dashboard(_props) {
  const [showUserProfileEditor, setShowUserProfileEditor] = useState(false);
  const userInfo = useSelector((state) => state.auth.userInfo);
  const token = useSelector((state) => state.auth.token);
  const expiresAt = useSelector((state) => state.auth.expiresAt);

  if (!isAuthenticated(token, expiresAt)) {
    return <Redirect to="/" />;
  }

  return (
    <div>
      <Header />
      {showUserProfileEditor ? (
        <UserProfileEditor setShowEditor={setShowUserProfileEditor} />
      ) : (
        <UserProfileView setShowEditor={setShowUserProfileEditor} />
      )}
      {userInfo.role === "STUDENT" ? (
        <ApplicationTable />
      ) : (
        <HiringSeasonTable />
      )}
      <Footer />
    </div>
  );
}

export default Dashboard;
